const CascaderPanel = window.ELEMENT.CascaderPanel;
const CascaderMenu = CascaderPanel.components.CascaderMenu
const CascaderNode = CascaderMenu.components.CascaderNode;

const handleCheckChange = CascaderNode.methods.handleCheckChange;
const handleMultiCheckChange = CascaderNode.methods.handleMultiCheckChange;

CascaderNode.mounted = function() {
  Object.defineProperty(this.node, "vm", {
    writable: true,
    value: this
  });
}

CascaderNode.beforeDestroy = function() {
  this.node.vm = null;
}

CascaderNode.methods.handleCheckChange = function() {
  handleCheckChange.call(this);
  if (this.config.checkStrictly && !this.node.isLeaf) {
    this.handleExpand();
  }
}

CascaderNode.methods.handleMultiCheckChange = function(checked) {
  handleMultiCheckChange.call(this, checked);
  if (this.config.checkStrictly && !this.node.isLeaf) {
    this.handleExpand();
  }
}

CascaderNode.methods.handleExpand = function(e, cb) {
  const { panel, node, isDisabled, config } = this;
  const { multiple, checkStrictly, lazy } = config;

  if (!checkStrictly && isDisabled || node.loading) return;

  if (e && checkStrictly) {
    let if1 = !lazy && !node.hasChildren;
    let if2 = lazy && (node.loaded && !node.hasChildren);
    if (if1 || if2) {
      if (multiple) {
        this.handleMultiCheckChange(!this.isChecked);
      } else {
        this.handleCheckChange();
      }
      return;
    }
  }

  if (config.lazy && !node.loaded) {
    panel.lazyLoad(node, () => {
      const { isLeaf } = this;
      if (!isLeaf) this.handleExpand();
      if (multiple) {
        const checked = isLeaf ? node.checked : false;
        this.handleMultiCheckChange(checked);
      } else if (isLeaf || !node.hasChildren) {
        this.handleCheckChange();
      }
      cb && this.$nextTick(() => {
        cb(node.children);
      })
    });
  } else {
    panel.handleExpand(node);
    cb && this.$nextTick(() => {
      cb(node.children);
    })
  }
}
